import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const FirstAlertMedicalSystemPage: React.FC = () => {
  const { getImage } = useImages();
  
  const circleImage1 = getImage('text-box-1-circle.jpg');
  const circleImage2 = getImage('text-box-2-circle.jpg');
  const circleImage3 = getImage('ppcAdNewLandingPageLandingPageImage02.png');
  const circleImage4 = getImage('701MonitoringMonitoring.jpg');
  const circleImage5 = getImage('pdpLowerOnTheGoInTheHomeFallDetectionMedicalAlert02.png');
  const circleImage6 = getImage('FD-circle2-text-box.png');

  return (
    <div className="first-alert-page">
      {/* Hero Section */}
      <section className="first-alert-hero-section">
        <div className="first-alert-hero-container">
          <h1 className="first-alert-hero-title">
            Your First Alert System Should Be Alert1-<br />Here's Why
          </h1>
          
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <p className="first-alert-hero-text">
                Alert1 members always tell us how much they love our service. But what exactly is it about us that makes them so happy? It's because we aren't just another company that sells medical alerts to seniors. Alert1 is the best{' '}
                <Link to="/compare" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  life alert alternative
                </Link>
                {' '}for both price and service.
              </p>
              
              <p className="first-alert-hero-text">
                We deliver on our promise to stay by your side whenever you need help. We provide affordability, reliability, value, and a commitment to safety.
              </p>
              
              <Link to="/medical-alerts" className="first-alert-view-btn">
                VIEW MEDICAL ALERTS
              </Link>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage1 ? (
                  <img 
                    src={circleImage1} 
                    alt="Happy couple with Alert1" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className="first-alert-hero-section first-alert-section-gray">
        <div className="first-alert-hero-container">
          <h2 className="first-alert-hero-title">
            Alert1 Keeps Seniors in the Homes They Love
          </h2>
          
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <p className="first-alert-hero-text">
                Seniors today overwhelmingly desire to age in place in their own homes. However, the realities of aging dictate that safety must always be a priority.
              </p>
              
              <p className="first-alert-hero-text">
                This is why an Alert1 help button is the perfect choice for any senior who wants to remain independent and safe while aging at home.
              </p>
              
              <Link to="/medical-alerts" className="first-alert-view-btn">
                VIEW MEDICAL ALERTS
              </Link>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage2 ? (
                  <img 
                    src={circleImage2} 
                    alt="Senior with child" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="first-alert-hero-section first-alert-section-white">
        <div className="first-alert-hero-container">
          <h2 className="first-alert-hero-title">
            Access to the Right Help 24/7
          </h2>
          
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <p className="first-alert-hero-text">
                When your first alert system is from Alert1, you will always have a live, trained professional standing by, 24/7. With the push of a button, help can be accessed in seconds.
              </p>
              
              <p className="first-alert-hero-text">
                Once the help button worn around the neck or wrist is pressed, you will be connected with an Alert1 emergency operator. The operator will ask if you need help. In addition to remaining calm and assessing the situation, the operator will alert up to three of your personal contacts that you would like to be notified.
              </p>
              
              <p className="first-alert-hero-text">
                Our emergency response operators can help guide the member to the right help quickly, without the risk of over or under reacting to a situation. They can send emergency services right away, or they can send a neighbor or nearby family member if that is more appropriate.
              </p>
              
              <Link to="/medical-alerts" className="first-alert-view-btn">
                VIEW MEDICAL ALERTS
              </Link>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage3 ? (
                  <img 
                    src={circleImage3} 
                    alt="Senior with medical alert device" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section */}
      <section className="first-alert-hero-section first-alert-section-gray">
        <div className="first-alert-hero-container">
          <h2 className="first-alert-hero-title">
            An Alert1 Medical Alert is Reliable
          </h2>
          
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <p className="first-alert-hero-text">
                Medical alert devices help provide seniors and their friends and families with peace of mind. A trained operator is standing by to ready to help at any time of the day.
              </p>
              
              <p className="first-alert-hero-text">
                Alert1 is committed to delivering the most reliable services to our members. Alert1's monitoring centers go through a rigorous certification process each year, run by the{' '}
                <a href="https://www.tma.us/" target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  The Monitoring Association (TMA)
                </a>
                . According to the TMA's official website, the organization is committed to five points of excellence that companies must pass to gain recognition. The TMA runs random inspections and quality criteria to ensure those in need during an emergency are being properly taken care of.
              </p>
              
              <Link to="/medical-alerts" className="first-alert-view-btn">
                VIEW MEDICAL ALERTS
              </Link>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage4 ? (
                  <img 
                    src={circleImage4} 
                    alt="Alert1 monitoring center operators" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section */}
      <section className="first-alert-hero-section first-alert-section-white">
        <div className="first-alert-hero-container">
          <h2 className="first-alert-hero-title">
            Alert1's Medical Alerts are Easy to Use
          </h2>
          
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <p className="first-alert-hero-text">
                Some people are wary of getting an Alert1 medical alarm because they think it may be difficult to install. However, getting started with an Alert1 medical alert system is fast and easy. Once your medical alert system arrives, all you need to do is plug it in-- it arrives pre-programmed. Place a test call by pressing the help button, and you will be all set!
              </p>
              
              <p className="first-alert-hero-text">
                If you need any help, Alert1's{' '}
                <Link to="/troubleshooting" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  technical support is available online
                </Link>
                {' '}or by phone 24 hours a day, 7 days a week.
              </p>
              
              <p className="first-alert-hero-text">
                Alert1 has been dedicated to helping seniors continue to live safely and independently in their own homes for over 37 years.
              </p>
              
              <div style={{ marginTop: '1.5rem' }}>
                <a href="tel:1-877-573-4195" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#0066cc', textDecoration: 'underline', display: 'block', marginBottom: '0.5rem' }}>
                  1-877-573-4195
                </a>
                <p style={{ margin: 0, color: '#333', fontSize: '1rem' }}>To ask about our products</p>
              </div>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage5 ? (
                  <img 
                    src={circleImage5} 
                    alt="Senior and child dancing" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sixth Section */}
      <section className="first-alert-hero-section first-alert-section-gray">
        <div className="first-alert-hero-container">
          <div className="first-alert-hero-content-wrapper">
            <div className="first-alert-hero-content">
              <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                  <span style={{ color: '#ff8c00', fontSize: '2.5rem' }}>★★★★★</span>
                  <span style={{ fontSize: '2.2rem', fontWeight: 700, color: '#000' }}>#1 Rated Medical Alert System</span>
                </div>
                <p style={{ margin: 0, fontSize: '1.4rem', color: '#333' }}>By Modern Senior Magazine</p>
              </div>
              
              <p style={{ fontSize: '1.6rem', lineHeight: 1.7, color: '#333', marginBottom: '2rem' }}>
                Alert1 is committed to keeping you safe so you can enjoy the peace of mind of 24/7 protection.
              </p>
              
              <div style={{ marginTop: '2rem', border: '2px solid #C0392B', padding: '2rem', borderRadius: '4px' }}>
                <p style={{ margin: 0, fontSize: '1.8rem', lineHeight: 1.6, color: '#C0392B' }}>
                  Call us today at{' '}
                  <a href="tel:1-877-573-4195" style={{ color: '#0066cc', textDecoration: 'underline', fontWeight: 700 }}>
                    1-877-573-4195
                  </a>
                  {' '}to get on the go protection with Alert1
                </p>
              </div>
            </div>
            
            <div className="first-alert-hero-image">
              <div className="circular-image-wrapper">
                {circleImage6 ? (
                  <img 
                    src={circleImage6} 
                    alt="Senior with child" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FirstAlertMedicalSystemPage;
